import { Box } from '@mui/material';
import LexoErrorCard from '@/components/LexoErrorCard';

export default function AppErrorFallback() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                minHeight: '100vh',
            }}
        >
            <LexoErrorCard />
        </Box>
    );
}
